{
  "name": "panicblaster",
  "version": "1.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 7010",
    "start:mock": "ng serve --configuration=mock --port 7012",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "jest",
    "test:watch": "jest --watch",
    "build:prod": "ng build --configuration production",
    "build:mock": "ng build --configuration mock",
    "serve:prod": "ng serve --configuration production",
    "deploy:prod": "npm run build:prod && node scripts/deploy.js",
    "deploy:s3": "npm run build:mock && aws s3 sync dist/membermanagement/browser s3://careerpathway --delete",
    "sync:s3": "aws s3 sync dist/membermanagement/browser s3://careerpathway --delete"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.1",
    "@angular/common": "^19.1.0",
    "@angular/compiler": "^19.1.0",
    "@angular/core": "^19.1.0",
    "@angular/forms": "^19.1.0",
    "@angular/platform-browser": "^19.1.0",
    "@angular/platform-browser-dynamic": "^19.1.0",
    "@angular/router": "^19.1.0",
    "@azure/msal-browser": "4.8.0",
    "@faker-js/faker": "^9.8.0",
    "@primeng/themes": "^19.0.5",
    "@types/leaflet": "^1.9.21",
    "ag-grid-angular": "^33.2.4",
    "apextree": "^1.3.0",
    "buffer": "^6.0.3",
    "chart.js": "^4.4.8",
    "chartjs-plugin-datalabels": "^2.2.0",
    "leaflet": "^1.9.4",
    "ngx-quill": "^27.0.0",
    "primeflex": "^3.3.1",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.3",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-builders/jest": "^19.0.1",
    "@angular-devkit/build-angular": "^19.1.1",
    "@angular/cli": "^19.1.1",
    "@angular/compiler-cli": "^19.1.0",
    "@types/jest": "^29.5.0",
    "@types/node": "^22.15.17",
    "@types/quill": "^2.0.14",
    "jest": "^29.5.0",
    "jest-preset-angular": "^14.5.5",
    "ts-jest": "^29.1.0",
    "typescript": "~5.7.2"
  }
}
